import api from "../api";

// Admin: Template Management
export const getAllTemplates = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "admin/templates", { params });
};

export const getTemplate = async (id) => {
  return api.getApi().get(api.getBaseUrl() + `admin/templates/${id}`);
};

export const createTemplate = async (data) => {
  return api.getApi().post(api.getBaseUrl() + "admin/templates", data);
};

export const updateTemplate = async (id, data) => {
  return api.getApi().put(api.getBaseUrl() + `admin/templates/${id}`, data);
};

export const deleteTemplate = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/templates/${id}`);
};

export const uploadTemplateImage = async (image) => {
  return api.getApi().post(api.getBaseUrl() + "admin/templates/upload", { image });
};

// Admin: User Template Management
export const getUserTemplates = async (userId) => {
  return api.getApi().get(api.getBaseUrl() + `admin/users/${userId}/templates`);
};

export const assignTemplateToUser = async (userId, templateId) => {
  return api.getApi().post(api.getBaseUrl() + "admin/users/templates/assign", { userId, templateId });
};

export const removeTemplateFromUser = async (userId, templateId) => {
  return api.getApi().delete(api.getBaseUrl() + `admin/users/${userId}/templates/${templateId}`);
};

// User: Template Management
export const getAvailableTemplates = async () => {
  return api.getApi().get(api.getBaseUrl() + "templates/available");
};

export const getMyActiveTemplates = async () => {
  return api.getApi().get(api.getBaseUrl() + "templates/my");
};

export const activateTemplate = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `templates/${id}/activate`);
};

export const deactivateTemplate = async (id) => {
  return api.getApi().post(api.getBaseUrl() + `templates/${id}/deactivate`);
};

export const reorderTemplates = async (templateOrders) => {
  return api.getApi().put(api.getBaseUrl() + "templates/reorder", { templateOrders });
};

